module.exports = __webpack_public_path__ + "img/box2BG.95eb7570.png";